import { Link } from "wouter";
import { Search, FileCheck, Handshake, Wallet, UserPlus, ShieldCheck } from "lucide-react";
import { useI18n } from "../lib/i18n";

const clients = [
  { i: FileCheck, t: "how.client.step1", d: "how.client.desc1" },
  { i: Search, t: "how.client.step2", d: "how.client.desc2" },
  { i: Handshake, t: "how.client.step3", d: "how.client.desc3" },
  { i: Wallet, t: "how.client.step4", d: "how.client.desc4" },
];
const workers = [
  { i: UserPlus, t: "how.worker.step1", d: "how.worker.desc1" },
  { i: ShieldCheck, t: "how.worker.step2", d: "how.worker.desc2" },
  { i: Search, t: "how.worker.step3", d: "how.worker.desc3" },
  { i: Wallet, t: "how.worker.step4", d: "how.worker.desc4" },
];

function Track({ title, steps, tone, t }: { title: string; steps: typeof clients; tone: string; t: (key: string) => string }) {
  return (
    <div className="card p-6">
      <h3 className="font-extrabold text-navy text-lg mb-5">{title}</h3>
      <div className="space-y-4">
        {steps.map((s, i) => {
          const I = s.i;
          return (
            <div key={s.t} className="flex gap-3">
              <div className={`w-10 h-10 rounded-lg grid place-items-center shrink-0 ${tone}`}><I className="w-5 h-5" /></div>
              <div><div className="font-semibold text-navy">{i + 1}. {t(s.t)}</div><div className="text-sm text-mut">{t(s.d)}</div></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function HowItWorks() {
  const { t } = useI18n();
  return (
    <div className="container-x py-10">
      <div className="text-center max-w-2xl mx-auto mb-8">
        <h1 className="text-3xl font-extrabold text-navy">{t("how.title")}</h1>
        <p className="text-mut mt-2">{t("how.intro")}</p>
      </div>
      <div className="grid lg:grid-cols-2 gap-4">
        <Track title={t("how.clients")} steps={clients} tone="bg-brand-red/10 text-brand-reddark" t={t} />
        <Track title={t("how.workers")} steps={workers} tone="bg-brand-green/10 text-brand-greendark" t={t} />
      </div>
      <div className="card p-5 mt-4 flex flex-col sm:flex-row sm:items-center gap-3 bg-navy-50/50">
        <ShieldCheck className="w-6 h-6 text-navy shrink-0" />
        <p className="text-sm text-navy/90 flex-1">{t("how.trust")}</p>
        <Link href="/safety" className="btn-navy h-9 px-4 text-sm shrink-0">Trust &amp; Safety</Link>
      </div>
    </div>
  );
}
